import { useIntl } from 'react-intl';
import { useConfigContext } from '@fe-core';

function getAfterLoginUrl() {
  const url = new URL(window.location.href);
  url.searchParams.set('op', 'enroll');

  return url.toString();
}

export const LoginAction = () => {
  const intl = useIntl();
  const { config } = useConfigContext();

  const loginHref = `${config?.baseUrls?.login}?redirect=${encodeURIComponent(getAfterLoginUrl())}`;

  return (
    <a className="l-btn l-btn-md l-btn-primary" href={loginHref}>
      {intl.formatMessage({ id: 'catalog.selfreg.login' })}
    </a>
  );
};
